
import React, { Component, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './css_files/registration.css'
import { Image } from 'cloudinary-react'
import axios from 'axios'
import { Search } from './search'
import { BarLoader, BeatLoader } from 'react-spinners';
import { RegistrationSearchPopup } from './search-register-modal';
// import {AmplifySignOut, withAuthenticator} from '@aws-amplify/ui-react'


// import "./Signup.css";

const RegisterForm =(props)=>
{


        return (
            <form onSubmit={(e) =>
            {
                props.submit(e)
            }}
                method='post' className='container  align-items-center justify-content-center FORM text-left p-5'>


                <div className='form-row'>
                    <div className='form-group'>
                        <label for="inputimage">Upload image &nbsp;</label>
                        <input type='file' name='image' onChange={props.handleImageChange} accept='image/*' id='inputimage' ></input>

                    </div>
                </div>
                <div className='form-row justify-content-between'>
                    <div className='form-group col-md-4 align-items-start'>
                        <div className='form-row'>
                            <div class="form-group ">
                                <label for="inputName">Registration Name</label>
                                <input name='name' value={props.dog.name} onChange={props.handleChange} type="text"  className='register-form-search-input' id="inputName" placeholder="Registration Name of Dog"></input>
                            </div>
                        </div>
                        <div className='form-row'>
                            <div class="form-group col-md-">
                                <label for="inputName">Kennel Name</label>
                                <input name='kennel_name' value={props.dog.kennel_name} onChange={props.handleChange}
                                    type="text"  className='register-form-search-input' id="inputName" placeholder="Kennel Name"></input>
                            </div>
                            <div class="form-group col-md-">
                                <label for="inputName">Current Owner</label>
                                <input name='current_owner' value={props.dog.current_owner} onChange={props.handleChange}
                                    type="text"  className='register-form-search-input' id="inputName" placeholder="Current Owner"></input>
                            </div>
                        </div>
                        <div className='form-row'>
                            <div class="form-group ">
                                <label for="inputName">AFBR NO</label>

                                <input name='afbr_no' value={props.dog.afbr_no} onChange={props.handleChange}
                                    type="number"  className='register-form-search-input' id="inputName" placeholder="AFBR NO."></input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md- raiseHigh">
                                <label for="inputSire">Registered Sire: {props.sire || "N/A"}</label>
                           

                                <RegistrationSearchPopup
                                    buttonTitle={'SELECT SIRE'}
                                    onSearchClick={props.handleChange} name='sire' 
                                    handleSireSelect={props.handleSireSelect} 
                                    />

                            </div>
                        </div>


                        <div class="form-row">
                            <div class="form-group col-md- raiseHigh">
                                <label for="inputSire">Registered Dam: {props.dam || "N/A"}</label>
                                {/* <p class='small'>Enter Unkown Genealogy if dam did not appear in searchlist</p> */}
                                <RegistrationSearchPopup
                                    buttonTitle={'SELECT DAM'}
                                    onSearchClick={props.handleChange} name='dam'
                                    handleSireSelect={props.handleSireSelect} 

                                    />

                            </div>
                        </div>
                    </div>

                    <div className='form-group col-md-6 align-items-start justify-content-start border_left_yellow pl-0 pl-sm-5'>

                        <div className='form-row '>
                            <p className='text-white'>Gender: &nbsp;</p>
                            <div class="form-group col-md-">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" onChange={props.handleChange} name="sex" value='male' id="male"></input>
                                    <label class="form-check-label" for="male">
                                        Male
                                    </label>
                                </div>
                            </div>
                            <div className='form-group col-md-'>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" onChange={props.handleChange} name="sex" value='female' id="female"></input>
                                    <label class="form-check-label" for="female">
                                        Female
                                    </label>
                                </div>
                            </div>


                        </div>

                        <div className='form-row '>
                            <div class="form-group col-md-">
                                <label for="inputDate">Weight: &nbsp;</label>
                                <input name='weight' value={props.dog.weight}
                                    onChange={props.handleChange}  className='register-form-search-input' type="number" id="Date"></input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-">
                                <label for="inputDate">Date of Birth:&nbsp;</label>
                                <input name='date_of_birth' value={props.dog.sex} onChange={props.handleChange}
                                     className='form-control' type="date" id="Date"></input>
                            </div>

                        </div>
                        <div className='form-row mt-4'>

                            <div class="form-group col-md-">
                                <label for="inputDate"> Place of Birth:&nbsp;</label>
                                <input name='place_of_birth' value={props.dog.place_of_birth}
                                    onChange={props.handleChange} 
                                    className='register-form-search-input '
                                    type="text" id="Date"></input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-">
                                <label for="Breed">Land of Standing</label>
                                <input name='land_of_standing' value={props.dog.land_of_standing}
                                    onChange={props.handleChange} type="text"  className='register-form-search-input m-1 px-2' id="Breed" placeholder="Land Of Standing"></input>
                            </div>

                        </div>
                        <div class="form-row">
                            <div class="form-group">
                                <label for="inputDam">Breed</label>
                                <select name='breed' onChange={props.handleChange} id="inputDam" className='register-form-search-input p-1'>
                                    <option name='breed' value='American Bulldog'>American Bulldog</option>
                                    <option name='breed' value='French Bulldog'>French Bulldog</option>
                                    <option name='breed' value='American Bully'>American Bully</option>
                                    <option name='breed' value='American XL Bully'>American XL Bully</option>





                                </select>

                            </div>

                        </div>
                        <div className='form-row'>
                            <div class="form-group col-md-">
                                <label for="inputDate">Height: &nbsp;</label>
                                <input name='height' value={props.dog.height} 
                                className='register-form-search-input'
                                onChange={props.handleChange}
                              type="number" id="Date"></input>
                            </div>
                        </div>

                    </div>
                </div>








                {/* {props.dpo_loaded && <button type="submit" class="register-form-button">Register</button>} */}
                {(!props.edit && !props.special) && <button type="submit" class="register-form-button btn-lg w-100 mt-5"
                   >Register</button>}

                {props.special && <button type="submit" class="register-form-button btn-lg w-100 mt-5" >Special Register</button>}
                {props.edit && <button type="submit" className="register-form-button btn-lg w-100 mt-5" >Edit</button>}
            </form>
        )
    }







export default RegisterForm;

